import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPhone(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 23C5.45 23 4.97917 22.8042 4.5875 22.4125C4.19583 22.0208 4 21.55 4 21V3C4 2.45 4.19583 1.97917 4.5875 1.5875C4.97917 1.19583 5.45 1 6 1H16C16.55 1 17.0208 1.19583 17.4125 1.5875C17.8042 1.97917 18 2.45 18 3V7H16V6H6V18H16V7H18V21C18 21.55 17.8042 22.0208 17.4125 22.4125C17.0208 22.8042 16.55 23 16 23H6ZM6 20V21H16V20H6ZM6 4H16V3H6V4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
